import React from "react";
import Context from "../../../Context";
import SVGDocCheck from "../SvgIcons/SVGDocCheck";
import FamDocModal from "./FamDocModal";

const listLimit = 300;

export default class FamStaff extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      pending: false,

      modalMode: this.props.defaultMode || "fam",

      listAll: [],
      listFam: [],
      listUnfam: [],
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.staffId !== this.props.staffId) {
      this.load();
    }
    if (prevProps.defaultMode !== this.props.defaultMode) {
      this.setState({ modalMode: this.props.defaultMode });
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let listAll = await this.context.api.qa("/familiarized/staff/list", {
      id: this.props.staffId || this.context.user.staffId,
      reclimit: listLimit,
      orderby: ["validfromdate DESC"],
    });
    let listFam = listAll.filter((item) => item.familiarized);
    let listUnfam = listAll.filter((item) => !item.familiarized);
    this.setState({ listAll, listFam, listUnfam, pending: false });
  };

  onModalShow = (mode) => {
    this.setState({ showModal: true, modalMode: mode });
  };

  onModalClose = () => {
    this.setState({ showModal: false });
  };

  onSwitchMode = () => {
    this.setState((state) => {
      return { modalMode: state.modalMode === "fam" ? "unfam" : "fam" };
    });
  };

  render() {
    const { listAll, listFam, listUnfam, pending } = this.state;
    if (pending) {
      return (
        <>
          <div className="spinner-border spinner-border-sm text-muted"></div>
        </>
      );
    }

    if (listAll.length > 0) {
      return (
        <>
          <FamDocModal
            show={this.state.showModal}
            onClose={this.onModalClose}
            list={this.state.modalMode === "fam" ? listFam : listUnfam}
            onClick={this.props.onClick}
            mode={this.state.modalMode}
            onSwitchMode={this.onSwitchMode}
            view="document"
          />
          <div className={this.props.className}>
            {listUnfam.length > 0 && this.props.showUnfam && (
              <div
                className="d-flex cursor-pointer"
                onClick={() => this.onModalShow("unfam")}
              >
                <div className="symbol symbol-40 bg-light mr-3">
                  <div className="symbol-label">
                    <span className={`svg-icon svg-icon-md svg-icon-danger`}>
                      <SVGDocCheck />
                    </span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <div className="font-weight-bold">
                    Ознакомление с документацией
                  </div>
                  <div className="text-muted">
                    <span className="label label-light-danger label-inline font-weight-bold">
                      {listUnfam.length < listLimit
                        ? listUnfam.length
                        : `Более ${listLimit}`}{" "}
                      ожидает
                    </span>
                  </div>
                </div>
              </div>
            )}
            {listFam.length > 0 &&
              listUnfam.length === 0 &&
              this.props.showFam && (
                <div
                  className="d-flex cursor-pointer"
                  onClick={() => this.onModalShow("fam")}
                >
                  <div className="symbol symbol-40 bg-light mr-3">
                    <div className="symbol-label">
                      <span className={`svg-icon svg-icon-md svg-icon-primary`}>
                        <SVGDocCheck />
                      </span>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <div className="font-weight-bold">
                      Ознакомление с документацией
                    </div>
                    <div className="text-muted">
                      <span className="label label-light label-inline font-weight-bold">
                        {listFam.length < listLimit
                          ? listFam.length
                          : `Более ${listLimit}`}{" "}
                        ознакомлен
                      </span>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </>
      );
    }
    return <></>;
  }
}
